//
//  FrameOriginModel.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class FrameOrigin {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, sourceId, sourceFrameId) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        this.sourceFileName = (_a = model.sourceFileName) !== null && _a !== void 0 ? _a : null;
        this.sourceFrameId = sourceFrameId;
        this.sourceId = sourceId;
        this.title = (_b = model.title) !== null && _b !== void 0 ? _b : null;
        this.previewUrl = (_c = model.previewUrl) !== null && _c !== void 0 ? _c : null;
        this.referenceId = (_d = model.referenceId) !== null && _d !== void 0 ? _d : null;
        this.valid = (_e = model.valid) !== null && _e !== void 0 ? _e : null;
        this.assetId = (_f = model.assetId) !== null && _f !== void 0 ? _f : null;
        this.assetScale = (_g = model.assetScale) !== null && _g !== void 0 ? _g : null;
        this.width = (_h = model.width) !== null && _h !== void 0 ? _h : null;
        this.height = (_j = model.height) !== null && _j !== void 0 ? _j : null;
    }
}
